import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

// Wraps protected routes. Shows a tiny loader while we check the session,
// redirects to /login (with ?next=...) when unauthenticated, and (optionally)
// to /404 when role check fails.
export const ProtectedRoute = ({ children, role }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center" data-testid="protected-route-loading">
        <Loader2 className="w-5 h-5 animate-spin text-foreground/50" />
      </div>
    );
  }
  if (user === null) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }
  return children;
};
